import {NavigationActions} from "@ignitesales/neuro-application/src/actions/navigation-action-creators";
import {extractAnswersWithPageInfo} from "../utils/initState";

//TODO: do this in Neuro for Summary page types in order to combine answers state with answersWithPageInfo path/page keys
const navigationReducer = (state, action) => {
  switch (action.type) {
    case NavigationActions.PAGE_REQUEST_COMPLETED: {
      const { nextPage } = action;

      return {
        ...state,
        answersWithPageInfo: extractAnswersWithPageInfo(nextPage)
      };
    }

    default:
      return state;
  }
};

export default navigationReducer;
